export default "__VITE_ASSET__DdmvowUn__"